
const ui = {
  navigation: {
    home: 'Home',
    about: 'About',
    work: 'Work',
    education: 'Education',
    skill: 'Skills',
    portfolio: 'Portfolio',
    testimonials: 'References'
  },
  navMenu: {
    showNav: 'Show navigation',
    hideNav: 'Hide navigation'
  },
  about: {
    title: 'About Me',
    subtitle: 'Contact Details'
  },
  skills: {
    title: 'Skills',
  },
  modal: {
    details: 'Details',
    close: 'Close'
  },
  portfolio: {
    title: 'Portfolio'
  },
  work: {
    title: 'Work'
  },
  education: {
    title: 'Education'
  },
  references: {
    title: 'References'
  },
  footer: {
    description: 
    `This site is developed in React.js by {author1} from the original design of Ceevee from {author2}. And it is refactored with ES6 by {author3}`,
    authorName: 'GuoXiaoyang'
  }
}
export default  ui;


// WEBPACK FOOTER //
// ./src/template/ui.en_US.js